import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../components/home/Home'
//import Marcas from '../pages/gestion/marcas/Marcas'
import Missing from './Missing'
import GestionConfigAlarma from '../pages/gestion/config/Alarma/GestionConfigAlarma'
//import Travel from '../components/travel/Travel'
//import Almacen from '../pages/almacen/Almacen'
//import GestionUsuarios from '../pages/gestion/usuarios/GestionUsuarios'
//import GestionMarcas from '../pages/gestion/marcas/GestionMarcas'
//import GestionProductos from '../pages/gestion/productos/GestionProductos'
//import PointOfSale from '../pages/caja/PointOfSale'
//import GestionProveedores from '../pages/gestion/proveedores/GestionProveedores'
//import GestionPreciosPan from '../pages/gestion/preciosPan/GestionPreciosPan'
import Dispositivos from '../pages/gestion/dispositivos/Dispositivos.jsx'
import ReporteEstado from '../pages/reportes/ReporteEstado.js'
import Usuarios from '../pages/gestion/usuarios/Usuarios.jsx'


const AppRoutes = () => {
    return (
        <Routes >

            <Route path="/" element={
                <Home />
            } />

            <Route path="/gestion/usuarios" element={
                <Usuarios />
            } />
            
            <Route path="/gestion/dispositivos" element={
                <Dispositivos />
            } />
 
            <Route path="/gestion/config/alarma" element={
                <GestionConfigAlarma />
            } />

            <Route path="/reportes/estado" element={
                <ReporteEstado />
            } />

            {/*
            <Route path="/pos" element={
                <PointOfSale />
            } />

            <Route path="/gestion/usuarios" element={
                <GestionUsuarios />
            } />

            <Route path="/gestion/productos" element={
                <GestionProductos />
            } />
            
            <Route path="/gestion/marcas" element={
                <GestionMarcas />
            } />

            <Route path="/gestion/proveedores" element={
                <GestionProveedores />
            } />


            <Route path="/travel" element={
                <Travel />
            } />
            */}

            <Route path="*" element={<Missing />} />

        </Routes>
    )
}

export default AppRoutes